import React from "react";
import { PageContainer } from "../../globals/components/containers";
import { LinkButton } from "../../globals/components/button";
import { EmileInfo } from "./styled_components/emile_info";
import { EmileDetailsContainer } from "./styled_components/your_emile";
import EggContainer from "./styled_components/egg_container";
import EmileStats from "./styled_components/emile_stats";
import EmilePetStatus from "./styled_components/emile_pet_status";
import food from "./assets/food.png";
import heart from "./assets/heart.png";
import styled from "styled-components";
import background from "./assets/background.png";
import { Scale } from 'react-scaling';
import Tama1 from "./assets/Rotten Reception.jpg";
import Tama2 from "./assets/Crossing Conundrum.jpg";
import Tama3 from "./assets/Scramblers Hideout.jpg";
import Tama4 from "./assets/Slinging Shots.jpg";

const YourEmileContainer = styled.div`
  display: flex;
  justify-content: center;
  position: fixed;
  align-items: center;
  height: 100%;
  background-image: url(${background});
  background-repeat: no-repeat;
  background-size: cover;
  padding: 2.5em;

  h1 {
    color: #673c8c;
    margin: 0;
    margin-bottom: 0.25em;
    font-size: 4em;
  }
`;

const Centered = styled.div`
 
`;

/*
        <div className="column">

          <div className="row" style={{position:"absolute"}}>
            
            <Gallery>
              <Image src={Tama1}></Image>
            </Gallery>
            <Gallery>
              <Image src={Tama2}></Image>
            </Gallery>
            <Gallery>
              <Image src={Tama3}></Image>
            </Gallery>
          </div>
          <div className="row" >
            <Centered>
              <h1>To raise your Emile, please download the app.</h1>
              <h1>To raise your Emile, please download the app.</h1>
              <LinkButton href={process.env.REACT_APP_DOWNLOAD_URL} target="_blank">
                Download App
        </LinkButton>
            </Centered>
          </div>
        </div>
*/

export default function YourStory() {
  return (
    <YourEmileContainer>
      <Scale scaleTo={1420}>
        <body>
          <Gallery>
            <a>
              <Image src={Tama1}></Image>
            </a>
          </Gallery>
          <Gallery>
            <a>
              <Image src={Tama2}></Image>
            </a>
          </Gallery>
          <Gallery>
            <a>
              <Image src={Tama3}></Image>
            </a>
          </Gallery>
          <Gallery>
            <a>
              <Image src={Tama4}></Image>
            </a>
          </Gallery>
        </body>
        <div>
          <h1 style={{ textAlign: "center" }}>Story Mode is only available on the App. The App is available for Windows computers, Chromebooks, iPads & iPhones, and Android tablets & phones.</h1>

          <LinkButton href={process.env.REACT_APP_DOWNLOAD_URL} target="_blank">
            Download App
        </LinkButton>
        </div>
      </Scale>
    </YourEmileContainer>
  );
}

const Image = styled.img`
width:100%;
height:auto;
`

const Gallery = styled.div`
padding: 0 6px;
  float: left;
  width: 24%;
`
